export default __webpack_public_path__ + "765eabeaa03349e1f725b82efab006a7.svg";